/*
 * Gift offer block
 *
 * This pass captures the customer's selection only:
 *   - which option is chosen ("deal" or "basic")
 *   - which gift variant is chosen (when on the "deal" option)
 *
 * It writes those into hidden inputs and fires a "gift-offer:change" event
 * so the cart wiring (added later) can read the selection at add-to-cart time.
 *
 * It does NOT add anything to the cart yet — that's the next step, once we
 * hook into the theme's add-to-cart flow.
 */

if (!customElements.get("gift-offer")) {
  customElements.define(
    "gift-offer",
    class GiftOffer extends HTMLElement {
      connectedCallback() {
        this.optionInputs = this.querySelectorAll(".gift-offer__input");
        this.giftInputs = this.querySelectorAll(".gift-offer__gift-input");
        this.selectedOptionField = this.querySelector("[data-gift-selected-option]");
        this.selectedVariantField = this.querySelector("[data-gift-selected-variant]");

        this.optionInputs.forEach((input) => {
          input.addEventListener("change", () => this.onOptionChange(input.value));
        });

        this.giftInputs.forEach((input) => {
          input.addEventListener("change", () => this.onGiftChange(input.value));
        });

        // Initialise visual state from whichever option is checked
        const checked = this.querySelector(".gift-offer__input:checked");
        this.onOptionChange(checked ? checked.value : "deal");
      }

      onOptionChange(option) {
        this.setAttribute("data-selected", option);
        if (this.selectedOptionField) this.selectedOptionField.value = option;
        this.emit();
      }

      onGiftChange(variantId) {
        if (this.selectedVariantField) this.selectedVariantField.value = variantId;
        this.emit();
      }

      /**
       * Current selection, for the cart wiring to read later.
       * @returns {{ option: string, giftVariantId: string|null }}
       */
      getSelection() {
        const option = this.selectedOptionField ? this.selectedOptionField.value : "deal";
        const giftVariantId =
          option === "deal" && this.selectedVariantField
            ? this.selectedVariantField.value || null
            : null;
        return { option, giftVariantId };
      }

      emit() {
        this.dispatchEvent(
          new CustomEvent("gift-offer:change", {
            bubbles: true,
            detail: this.getSelection(),
          }),
        );
      }
    },
  );
}